export default __webpack_public_path__ + "static/media/gamony-icon.7710f47f.svg";